//@ts-nocheck

import {ISalonsRepository} from "@/repository/salons/SalonsRepository.types";
import {ISalons, ISalonsListItem, SalonsListItemResponseType, SalonsResponseType} from "@/entity/salons/salons.types";
import Api from "@/repository/api";
import Salons from "@/entity/salons/salons";
import {SalonGeneralRequestType} from "@/form/salonGeneral/salonGeneral.types";
import qs from "qs";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import {ResponseDataType} from "@/form/form.types";
import {Vue} from "vue-property-decorator";




export class SalonsRepository implements ISalonsRepository {
    
    async fetchAll(data?: FormData): Promise<ISalons> {
          
        const response = await Api.get(`/salons/get`, {params: data, paramsSerializer: function paramsSerializer(params) {

            return (new URLSearchParams(params).toString())
            // return  qs.stringify(params, {arrayFormat: 'indices', encodeValuesOnly:true})
        }});
        const responseData = response.data as SalonsResponseType;
        return new Salons(responseData);
    }

    async customFetchData(source:number[]): Promise<ISalons> {
        let url=''
        source.forEach((data,key:number)=>{
            url=url.concat(`filter[id][${key}]=${data}&`)
        })

        const response= await Api.get('/salons/get?'+url)
        const responseData = response.data as SalonsResponseType;
        return new Salons(responseData);
    }

    async fetchData(data: PaginationRequestType): Promise<ISalonsListItem> {
        function filterFunc(prefix:any, value:any) {
            if (prefix == '[id]') {
                return value;
            }
            return value;
        }
        const response = await Api.get(`/salons/get`, {params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat:'repeat', encodeValuesOnly:true})
                //return qs.stringify(params, {arrayFormat: 'brackets', encodeValuesOnly:true})
                //return qs.stringify(params, {arrayFormat: 'brackets', encodeValuesOnly:true, filter: filterFunc}   )
            }});
        const responseData = response.data as SalonsResponseType;
        return new Salons(responseData).data[0];
    }
    async create(data: SalonGeneralRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/salons/create`, data);
        return response.data;

    }
    async update(data: SalonGeneralRequestType): Promise<ResponseDataType> {
        console.log('++++++++++++++++++++1673558030++++++++++++++++++++++++');console.log('data : ' + (typeof data));console.log(data);console.log('--------------------1673558030------------------------');

        const response = await Api.post(`/salons/update`, data);
        return response.data;

    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const response = await Api.post(`/salons/delete`, data);
        return response.data;
    }
}
